export default "__VITE_ASSET__2a873ac5__"